/// <reference types="facebook-pixel" />

import {hasWindow} from 'utils/functions';

export const facebook = {
	purchase: (value: number) => {
		if (hasWindow() && window.fbq) {
			window.fbq('track', FBEvent.Purchase, {
				currency: 'USD',
				value,
			});
		}
	},

	viewContent: () => {
		if (hasWindow() && window.fbq) {
			window.fbq('track', FBEvent.ViewContent);
		}
	},
};

enum FBEvent {
	Purchase = 'Purchase',
	ViewContent = 'ViewContent',
}
